export default __webpack_public_path__ + "47ebd2b1695a6dbf88d3bcc0a1878a29.svg";